import angular from 'angular';
import blogComponent from './blog.component';
import BlogService from './blog.service';
import blogConfig from './blog.config';
import blogDetailModule from './blog-detail/blog-detail';
import blogSliderModule from './blog-slider/blog-slider';
import relatedPostsModule from './related-posts/related-posts';


let blogModule = angular.module('app.blog',[blogDetailModule.name,blogSliderModule.name,relatedPostsModule.name])
  .component('blog', blogComponent)
  .service('BlogService', BlogService)
  .config(blogConfig);

export default blogModule;



// WEBPACK FOOTER //
// ./www/components/blog/blog.js